import type {
  AuthResponse,
  LoginCredentials,
  SignupCredentials,
} from '@/types/user';

import { apiClient, apiRequest } from '../api/client';
import type { ApiResult } from '../api/types';

export async function login(
  credentials: LoginCredentials
): Promise<ApiResult<AuthResponse>> {
  return apiRequest(() =>
    apiClient.post<AuthResponse>('/auth/login', credentials)
  );
}

export async function signup(
  credentials: SignupCredentials
): Promise<ApiResult<AuthResponse>> {
  return apiRequest(() =>
    apiClient.post<AuthResponse>('/auth/signup', credentials)
  );
}

export async function forgotPassword(email: string): Promise<ApiResult<void>> {
  return apiRequest(() =>
    apiClient.post<void>('/auth/forgot-password', { email })
  );
}

export async function resetPasswordWithToken(
  token: string,
  password: string
): Promise<ApiResult<{ message: string }>> {
  return apiRequest(() =>
    apiClient.post<{ message: string }>('/auth/email-reset-password', {
      token,
      password,
    })
  );
}

export async function resetPassword(
  email: string,
  password: string
): Promise<ApiResult<{ message: string }>> {
  return apiRequest(() =>
    apiClient.post<{ message: string }>('/auth/reset-password', {
      email,
      password,
    })
  );
}

export async function refreshToken(
  token: string
): Promise<ApiResult<AuthResponse>> {
  return apiRequest(() =>
    apiClient.post<AuthResponse>('/auth/refresh', { token })
  );
}
